import VideoPlayer from '../shared/videoPlayer';

const builderForwardVideoGenerationTimeout = 300; //in seconds

$(function () {
    if ($('#builderforward_confirmation_page').length) {
        $(function () {
            var confirmationNumber = $('#hdnConfirmationNumber').val();

            var $loading = $('#ll_loading-div').hide();
            var button = $('#attach-button');
            var input = $('#attach-input');
            var logobutton = $('#logo-attach-button');
            var logoinput = $('#logo-attach-input');
            var form = new FormData();
            form.append("confirmationNumber", confirmationNumber);

            var exist = $("#hdnConfirmExists").val();

            if (exist) {
                if ($("#slopenimg").attr('src') == "") {
                    $.ajax({
                        url: 'generate-promotional-flyer',
                        type: 'POST',
                        cache: false,
                        contentType: false,
                        processData: false,
                        data: form,
                        beforeSend: function () {
                            $("#slopenimg").attr("src", "https://cloud.cmgfi.com/dvbdysuf5/image/upload/CMG_Web_Resources/Shared_Images/ll-loading.gif");
                        },
                        success: function (response) {
                            if (response != "") {
                                response = response.replace("/upload/", "/upload/fl_attachment:PromoFlyer/")
                                $("#slopenlink").attr("href", response);
                                $("#slopenimg").attr("src", response.replace(".pdf", ".png"));
                            }
                        }
                    });
                }

                if ($("#socialpmtopenimg").attr('src') == "") {
                    $.ajax({
                        url: 'generate-builder-socialPMT',
                        type: 'POST',
                        cache: false,
                        contentType: false,
                        processData: false,
                        data: form,
                        beforeSend: function () {
                            $("#socialpmtopenimg").attr("src", "https://cloud.cmgfi.com/dvbdysuf5/image/upload/CMG_Web_Resources/Shared_Images/ll-loading.gif");
                        },
                        success: function (response) {
                            if (response != "") {
                                response = response.replace("/upload/", "/upload/fl_attachment:SocialPostFlyer/")
                                $("#socialpmtopenlink").attr("href", response);
                                $("#socialpmtopenimg").attr("src", response.replace(".pdf", ".png"));
                            }
                        }
                    });
                }

                if ($("#educationpostimg").attr('src') == "") {
                    $.ajax({
                        url: 'generate-featured-rate-post',
                        type: 'POST',
                        cache: false,
                        contentType: false,
                        processData: false,
                        data: form,
                        beforeSend: function () {
                            $("#educationpostimg").attr("src", "https://cloud.cmgfi.com/dvbdysuf5/image/upload/CMG_Web_Resources/Shared_Images/ll-loading.gif");
                        },
                        success: function (response) {
                            if (response != "") {
                                response = response.replace("/upload/", "/upload/fl_attachment:FeaturedRateFlyer/")
                                $("#educationpostlink").attr("href", response);
                                $("#educationpostimg").attr("src", response.replace(".pdf", ".png"));
                            }
                        }
                    });
                }
            }

            $('#new-rate').on('change', function (e) {
                $("#current_rate").removeClass('d-none');

                var currentRate = $("#current_rate").data('rate');
                if (this.value == currentRate)
                    $("#update_featured").addClass('d-none');
                else
                    $("#update_featured").removeClass('d-none');
            });

            function BuildFormData(files) {
                var data = new FormData();
                data.append("confirmationNumber", confirmationNumber);

                for (var i = 0; i < files.length; i++) {
                    data.append(files[i].name, files[i]);
                }

                return data;
            }

            button.on('click', function (e) {
                e.preventDefault();
                input.click();
            });

            logobutton.on('click', function (e) {
                e.preventDefault();
                logoinput.click();
            });

            input.on('change', function (e) {
                var data = BuildFormData(e.target.files);

                var url = window.location.origin + window.location.pathname + '/upload-listing-image';

                $.ajax({
                    type: 'POST',
                    url: url,
                    contentType: false,
                    processData: false,
                    data: data,
                    beforeSend: function () {
                        $("#listing-image-form").addClass("d-none");
                        $("#form-listing-image").addClass("d-none");
                        $("#loading-img-listing").removeClass("d-none");
                        $('#listing_image').prop('src', 'https://cloud.cmgfi.com/dvbdysuf5/image/upload/CMG_Web_Resources/Shared_Images/ll-loading.gif');
                    },
                    success: function (result) {
                        if (result.success) {
                            location.reload();
                            return;
                        }

                        console.log(result.error);
                        $("#form-listing-image").removeClass("d-none");
                        $("#listing-image-form").removeClass("d-none");
                        $("#loading-img-listing").addClass("d-none");
                        $('#listing_image').prop('src', $('#listing_image').data('backup-src'))
                    },
                    error: function (XMLHttpRequest, textStatus, errorThrown) {
                        console.log("Status: " + textStatus); alert("Error: " + errorThrown);

                        $('#loading-builderlogo').addClass('d-none');
                    }
                });
            });

            logoinput.on('change', function (e) {
                var data = BuildFormData(e.target.files);

                var url = window.location.origin + window.location.pathname + '/upload-builder-logo';

                $.ajax({
                    type: 'POST',
                    url: url,
                    contentType: false,
                    processData: false,
                    data: data,
                    beforeSend: function () {
                        $('#loading-builderlogo').removeClass('d-none');
                        $("#builder-logo-form").addClass("d-none");
                    },
                    success: function (result) {
                        if (result.success) {
                            location.reload();
                            return;
                        }

                        console.log(result.error);
                        $("#builder-logo-form").removeClass("d-none");
                        $('#loading-builderlogo').addClass('d-none');
                    },
                    error: function (XMLHttpRequest, textStatus, errorThrown) {
                        console.log("Status: " + textStatus); alert("Error: " + errorThrown);

                        $('#loading-builderlogo').addClass('d-none');
                    }
                });
            });

            $('#buttonSendMarketingCollateral').on('click', function (e) {
                e.preventDefault();

                var data = new FormData();
                data.append("confirmationNumber", confirmationNumber);
                data.append("builder-email", $("#builder-email").val());

                $.ajax({
                    url: window.location.origin + window.location.pathname + '/send-marketing-collateral',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: data,
                    beforeSend: function () {
                        $loading.show();
                    },
                    success: function (response) {
                        $loading.hide();
                        if (response.success) {
                            alert("Email sent successfully!")
                            return;
                        }
                    }
                });
            });

            $('#new_sales_price').on('focus', function (e) {
                if ($(this).val() === '$0') {
                    $(this).val('');
                }
            });

            $('#new_sales_price').on('keyup change', function (e) {
                $('#update_price_error_message').addClass('d-none');
                $('#no_rates_message').addClass('d-none');

                var filteredValue = $(this).val().replace(/\D/g, '');
                if (!filteredValue) {
                    $(this).val('$0');
                    return;
                }

                var curValue = Number($('#current_sales_price').val().replace(/\D/g, ''));
                var newValue = Number(filteredValue);
                $(this).val(newValue.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }));

                if (Math.abs(1 - newValue / curValue) < 0.25) {
                    $('#update_price').prop("disabled", false);
                }
                else
                    console.log('current diff: ' + Math.abs(1 - newValue / curValue));
            });

            $('#new_sales_price').on('blur', function (e) {
                $('#update_price_error_message').addClass('d-none');
                $('#no_rates_message').addClass('d-none');

                var newValue = Number($('#new_sales_price').val().replace(/\D/g, ''));
                if (newValue == 0)
                    return;

                var curValue = Number($('#current_sales_price').val().replace(/\D/g, ''));

                console.log('price diff: ' + Math.abs(1 - newValue / curValue));
                if (Math.abs(1 - newValue / curValue) > 0.25) {
                    $('#price_error_message').removeClass('d-none');
                    $('#update_price').prop("disabled", true);
                }
                else {
                    $('#price_error_message').addClass('d-none');
                    $('#update_price').prop("disabled", false);
                }
            });

            $('#update_price, #revert_original_price').on('click', function (e) {
                $('#price_change_form').parent().addClass('d-none');
                $('#loading-img-price').removeClass('d-none');

                $('#update_price_error_message').addClass('d-none');
                $('#no_rates_message').addClass('d-none');

                var postUrl = $(this).attr('id') == 'update_price'
                    ? `update-price?confirmationNumber=${confirmationNumber}&newPrice=${Number($('#new_sales_price').val().replace(/\D/g, ''))}`
                    : `update-price?confirmationNumber=${confirmationNumber}`;

                $.post(postUrl)
                    .done(function (data, textStatus, jqXHR) {
                        if (data == 'no data') {
                            $('#update_price_error_message').removeClass('d-none');
                        }
                        if (data == 'no rates') {
                            $('#no_rates_message').removeClass('d-none');
                        }
                        else
                            location.reload();
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        $('#update_price_error_message').removeClass('d-none');

                        $('#price_change_form').parent().removeClass('d-none');
                        $('#loading-img-price').addClass('d-none');
                    });
            });

            $('#update_featured').on('click', function (e) {
                e.preventDefault();

                $("#loading-img-featured").removeClass("d-none");
                $('#featured_update_error_message').removeClass('d-none');
                $('#featured_rate_form').parent().addClass('d-none');
                var postUrl = $(this).attr('id') == 'update_featured'
                    ? `update-featured?confirmationNumber=${confirmationNumber}&lockrate=${$("#new-rate option:selected").val()}`
                    : `update-featured?confirmationNumber=${confirmationNumber}`;

                $.post(postUrl)
                    .done(function (data, textStatus, jqXHR) {
                        $("#loading-img-featured").addClass("d-none");
                        location.reload();
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        $('#featured_update_error_message').removeClass('d-none');
                        $('#featured_rate_form').parent().removeClass('d-none');
                        $('#loading-img-featured').addClass('d-none');
                    });
            });

            $('#revert_featured').on('click', function (e) {
                e.preventDefault();

                $("#loading-img-featured").removeClass("d-none");
                $('#featured_update_error_message').addClass('d-none');
                $('#featured_rate_form').parent().addClass('d-none');

                $.post(`revert-featured?confirmationNumber=${confirmationNumber}`)
                    .done(function (data, textStatus, jqXHR) {
                        location.reload();
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        $('#featured_update_error_message').removeClass('d-none');
                        $('#featured_rate_form').parent().removeClass('d-none');
                        $('#loading-img-featured').addClass('d-none');
                    });
            });

            if ($('#property_video').is('.pending')) {
                var propertyVideoStatusCheckCounter = 0;

                var timer = setInterval(() => {
                    $.get(`/lock-products/video-upload-status?confirmationNumber=${confirmationNumber}&videoType=custom`)
                        .done(function (data, textStatus, jqXHR) {
                            if (data.videoUrl && data.videoUrl.length > 0) {
                                propertyVideoStatusCheckCounter = builderForwardVideoGenerationTimeout;

                                $('#property_video [data-role="thumbnail"]').attr('data-src', data.previewURL);
                                $('#property_video [data-role="play-button"]').attr('href', data.videoUrl);
                                $('#property_video').removeClass('pending');
                                $('#property_video_loading').addClass('d-none');
                                new VideoPlayer();

                                $('[download="CustomVideo"]').prop('href', data.videoFile);
                                $('[download="CustomVideo"]').parent().removeClass('d-none');

                                $('#property_video_qr').removeClass('d-none');
                                $('#property_video_qr_loading').addClass('d-none');

                                $('[download="VideoQRCode"]').prop('href', data.qrFile);
                                $('[download="VideoQRCode"]').parent().removeClass('d-none');

                                $('#instructions-div').addClass('d-none');
                            }
                        })
                        .fail(function (jqXHR, textStatus, errorThrown) {
                            propertyVideoStatusCheckCounter = builderForwardVideoGenerationTimeout;
                        })
                        .always(function () {
                            propertyVideoStatusCheckCounter++;

                            if (propertyVideoStatusCheckCounter > builderForwardVideoGenerationTimeout) {
                                $('#instructions-div p').text('Unable to generate customized video.Please try again.').addClass('upload-error');
                                clearInterval(timer);
                            }
                        });
                }, 2000);
            }

            if ($('#educational_video').is('.pending')) {
                var socialVideoStatusCheckCounter = 0;

                var timer1 = setInterval(() => {
                    $.get(`/lock-products/video-upload-status?confirmationNumber=${confirmationNumber}&videoType=social`)
                        .done(function (data, textStatus, jqXHR) {
                            if (data.videoUrl && data.videoUrl.length > 0) {
                                socialVideoStatusCheckCounter = builderForwardVideoGenerationTimeout;

                                $('#educational_video [data-role="thumbnail"]').attr('data-src', data.previewURL);
                                $('#educational_video [data-role="play-button"]').attr('href', data.videoUrl);
                                $('#educational_video').removeClass('pending');
                                $('#educational_video_loading').addClass('d-none');
                                new VideoPlayer();

                                $('[download="CustomVideo1"]').prop('href', data.videoFile);
                                $('[download="CustomVideo1"]').parent().removeClass('d-none');

                                $('#instructions-edu-div').addClass('d-none');
                            }
                        })
                        .fail(function (jqXHR, textStatus, errorThrown) {
                            socialVideoStatusCheckCounter = builderForwardVideoGenerationTimeout;
                        })
                        .always(function () {
                            socialVideoStatusCheckCounter++;

                            if (socialVideoStatusCheckCounter > builderForwardVideoGenerationTimeout) {
                                $('#instructions-edu-div p').text('Unable to generate customized video.Please try again.').addClass('upload-error');
                                clearInterval(timer1);
                            }
                        });
                }, 2000);
            }

            if ($('#reorder_signrider').length) {
                var script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAiTYeI5JpL0iYv5WskHudfIQwHKvZVK6E&libraries=places&callback=GinitMap2';
                script.async = true;
                document.body.appendChild(script);

                $('[data-toggle="tooltip"]').tooltip();

                $('#reorder_signrider').on('click', function () {
                    $('#signrider_reorder_dialog').addClass('show');
                });

                $('#signrider_newaddress').on('change', function () {
                    $('#signrider_address_form').toggleClass('active');
                    $('.pac-container').css('z-index', '10001');
                });

                $('#cancel_reorder').on('click', function () {
                    $('#address_form_error, #signrider_order_error').addClass('d-none');

                    $('#street_number').val('');
                    $('#route').val('');
                    $('#locality').val('');
                    $('#administrative_area_level_1').val('');
                    $('#postal_code').val('');

                    $('#signrider_reorder_dialog').removeClass('show');

                    $("#signrider_newaddress").prop("checked", false);
                    $('#signrider_address_form').removeClass('active');
                });

                $('#confirm_reorder').on('click', function () {
                    $('#signrider_order_error').addClass('d-none');

                    if ($('#signrider_newaddress').is(':checked')) {
                        var streetNumber = $('#street_number').val();
                        var streetName = $('#route').val();
                        var city = $('#locality').val();
                        var state = $('#administrative_area_level_1').val();
                        var zip = $('#postal_code').val();

                        if (!streetNumber.length || !streetName.length || !city.length || !state.length || !zip.length) {
                            $('#address_form_error').text('Please enter a valid shipping address').removeClass('d-none');
                            return;
                        }
                    }

                    $.post({
                        url: "reorder-yard-sign?confirmation=" + $('#hdnConfirmationNumber').val(),
                        data: { streetNumber, streetName, city, state, zip },
                        beforeSend: function () {
                            $('.dialog-content, .dialog-buttons').addClass('d-none');
                            $('.dialog-loading').removeClass('d-none');
                        }
                    })
                        .done(function () {
                            $('#success_message, #close_reorder').removeClass('d-none');
                            $('#cancel_reorder, #confirm_reorder').addClass('d-none');
                            $('.dialog-content').children().not('#success_message').addClass('d-none');
                        })
                        .fail(function () {
                            $('#address_error').removeClass('d-none');
                            $('#signrider_order_error').removeClass('d-none').children().first().text('Unable to place new sign rider order. Please try again.');
                        })
                        .always(function () {
                            $('.dialog-content, .dialog-buttons').removeClass('d-none');
                            $('.dialog-loading').addClass('d-none');
                        });
                });

                $('#autocomplete').bind("cut copy paste", function (e) {
                    e.preventDefault();
                });

                $('#close_reorder').on('click', function () {
                    $('#signrider_reorder_dialog').removeClass('show');
                    $('#reorder_signrider').parent().addClass('d-none');
                });
            }
        });
    }
});